export * from './lorem';
export * from './logo';